import { render, staticRenderFns } from "./CardFileInput.vue?vue&type=template&id=9c64eb78&scoped=true"
import script from "./CardFileInput.vue?vue&type=script&lang=js"
export * from "./CardFileInput.vue?vue&type=script&lang=js"
import style0 from "./CardFileInput.vue?vue&type=style&index=0&id=9c64eb78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c64eb78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VBtn,VCard,VIcon,VResponsive})
